function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { AutoComplete, findSuggestionFromList } from "../../../../portal";
const TownsAutoComplete = ({
  selectedTown,
  onValueChange,
  containerClass,
  towns,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, /*#__PURE__*/React.createElement(AutoComplete, _extends({
    value: towns && selectedTown ? findSuggestionFromList(towns, {
      value: selectedTown
    }) : null,
    suggestions: towns ? towns : [],
    onChange: onValueChange,
    name: "townsAutoComplete"
  }, rest)));
};
export default TownsAutoComplete;
TownsAutoComplete.propTypes = {
  selectedTown: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  containerClass: PropTypes.string,
  towns: PropTypes.array.isRequired
};